<div class="scene-import" >
    <h4 class="title">{{ 'scenes.components.sceneImport.title' | translate }}</h4>
    <div class="h-100" *ngIf="dataLoaded">
        <div
            class="scene-import__main-scene"
        >
            <form class="scene-import-form" [formGroup]="importSceneForm" (ngSubmit)="openImportDialog()">
            <div class="tryb-dropdown">
                <select
                    id="scene-definition-dropdown"
                    [formControl]="importSceneForm.get('dropdownControl')"
                    (change)="setSelectedSceneDefinition($event.target['value'])"
                >
                    <option
                        *ngFor="let sceneDefinition of sceneDefinitions"
                        [value]="sceneDefinition.name"
                        [id]="sceneDefinition.name"
                    >
                        {{ sceneDefinition.name }}
                    </option>
                </select>
            </div>
            <button class="import-button"  type="submit" [disabled]="importSceneForm.disabled || !importSceneForm.get('dropdownControl').value">
                {{ 'scenes.components.sceneImport.importButton' | translate }}
            </button>
            </form>
        </div>
    </div>
</div>
